var React = require('react');

function Rect (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.5115 37.0897C11.5115 37.0897 14.3128 30.0603 22.349 30.7498C29.3936 31.3544 30.2808 28.3776 30.2808 28.3776C30.2808 28.3776 23.0479 20.596 20.3245 12.9314C18.2583 7.11721 20.7153 0.496742 20.7153 0.496742C20.7153 0.496742 18.8923 4.18987 8.92028 5.35252C5.8489 5.71059 0.646155 4.5808 0.646155 4.5808C0.646155 4.5808 0.889151 14.0891 2.93535 21.1767C4.98155 28.2643 11.5115 37.0897 11.5115 37.0897Z","fill":"#4187F5"}));
}

Rect.defaultProps = {"width":"31","height":"38","viewBox":"0 0 31 38","fill":"none"};

module.exports = Rect;

Rect.default = Rect;
